import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeCompanySearchQuerySchema = z
    .object({
        name: z.string(),
        country: z.string(),
        province: z.string().nullish(),
    })
    .strict();

export class CreditSafeCompanySearchQuery extends FromSchema(CreditSafeCompanySearchQuerySchema) {
    name: string;
    country: string;
    province?: string | null;
}
